import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@material-ui/core';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { renderUserGoal } from 'src/data/benchmark';
import { TruncatedTypography } from 'src/components/TruncatedTypography';
import { IconSettings } from 'src/assets/icons/IconSettings';
import { useStyles } from './useStyles';

const TooltipContent = ({ name, description }) => {
  if (!name || !description) {
    return;
  }

  return (
    <div>
      <CustomTypography variant={TYPOGRAPHY_VARIANT.paragraph14}>
        This is the set of texts we found in your account that we are comparing your copy with.
      </CustomTypography>
      <br />
      <CustomTypography variant={TYPOGRAPHY_VARIANT.semiBold12}>
        <b>Benchmark set: {name}</b>
      </CustomTypography>
      <CustomTypography variant={TYPOGRAPHY_VARIANT.paragraph14}>{description}</CustomTypography>
    </div>
  );
};

TooltipContent.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
};

TooltipContent.defaultProps = {
  name: null,
  description: null,
};

export const ConnectedBenchmark = ({ onSettingsClick, benchmarkConfig }) => {
  const styles = useStyles();

  return (
    <div>
      <CustomTypography variant={TYPOGRAPHY_VARIANT.medium12}>Projected ranking</CustomTypography>
      <CustomTypography
        className={styles.title}
        variant={TYPOGRAPHY_VARIANT.regular14}
      >
        <span>#{benchmarkConfig.position}</span> of {benchmarkConfig.comparisonSet?.examples.length}{' '}
        Similar texts
      </CustomTypography>
      <div className={styles.benchmarkConfig}>
        <Tooltip
          classes={{ tooltip: styles.tooltip }}
          title={
            <TooltipContent
              name={benchmarkConfig.comparisonSet?.name}
              description={benchmarkConfig.comparisonSet?.description}
            />
          }
          arrow
        >
          <CustomTypography
            className={styles.userGoal}
            variant={TYPOGRAPHY_VARIANT.regular12}
          >
            Benchmark set: {benchmarkConfig.comparisonSet?.name}
          </CustomTypography>
        </Tooltip>
        <span className={styles.bullet}>∙</span>
        <TruncatedTypography
          className={styles.userGoal}
          title={renderUserGoal(benchmarkConfig.comparisonSet?.userGoal)}
          variant={TYPOGRAPHY_VARIANT.regular12}
        >
          Benchmark by: {renderUserGoal(benchmarkConfig.comparisonSet?.userGoal)}
        </TruncatedTypography>
        <span className={styles.bullet}>∙</span>
        <IconButton
          onClick={onSettingsClick}
          className={styles.settingsButton}
        >
          <IconSettings className={styles.settingsIcon} />
        </IconButton>
      </div>
    </div>
  );
};

ConnectedBenchmark.propTypes = {
  onSettingsClick: PropTypes.func.isRequired,
  benchmarkConfig: PropTypes.shape({
    account: PropTypes.shape({
      name: PropTypes.string,
      channel: PropTypes.string,
    }),
    comparisonSet: PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
      examples: PropTypes.array,
      userGoal: PropTypes.string,
    }),
    position: PropTypes.number,
    loadingGlobalBenchmark: PropTypes.bool,
    shouldUpgrade: PropTypes.bool,
  }).isRequired,
};
